<template>
  <div class="combine-resume-wrapper">
    <transition name="fade">
      <div v-if="visible" class="background-cover" @click="close"></div>
    </transition>
    <transition name="scale">
      <div v-if="visible" class="combine-cv-container">
        <div class="main_header">
          <div class="header_title">合并中英文</div>
          <div class="close" @click.stop="close">
            <i class="iconfont iconx"></i>
          </div>
        </div>
        <div class="main_body">
          <div v-if="defaultCvFirst" class="resume-select">
            <div class="resume-select-title">
              {{ this.cv_lang === "cn" ? "中文简历" : "英文简历" }}
            </div>
            <div class="resume-select-value">
              <img
                class="icon"
                src="https://files.wondercv.com/service_cv.png"
              />
              <div class="text">
                {{ cv_name }}
              </div>
            </div>
            <div
              v-if="defaultCvFirst"
              class="resume-select-switch"
              @click="switchOrder()"
            >
              <el-tooltip
                class="item"
                effect="dark"
                content="调整顺序"
                placement="top"
              >
                <i class="iconfont icontiaozhengshunxu" />
              </el-tooltip>
            </div>
          </div>
          <div class="resume-select">
            <div class="resume-select-title">
              {{ this.cv_lang === "cn" ? "英文简历" : "中文简历" }}
            </div>
            <div class="resume-select-select">
              <el-select
                v-model="otherCvToken"
                placeholder="请选择您的简历"
                popper-class="resume-merge-select-popper"
                style="width: 100%"
              >
                <template v-if="!!otherCvs.length">
                  <el-option
                    class="combine-select-option"
                    v-for="item in otherCvs"
                    :key="item.token"
                    :value="item.token"
                    :label="item.cv_name"
                  >
                    {{ item.cv_name }}
                  </el-option>
                </template>
                <template v-else>
                  <el-option
                    class="combine-select-option"
                    key="noresume"
                    value="noresume"
                    label="当前暂无简历"
                  >
                    <div class="no-resume" @click="goToMoban">
                      <i class="iconfont iconplus-circle" />
                      创建/导入简历
                    </div>
                  </el-option>
                </template>
              </el-select>
            </div>
            <div
              v-if="!defaultCvFirst"
              class="resume-select-switch"
              @click="switchOrder()"
            >
              <el-tooltip
                class="item"
                effect="dark"
                content="调整顺序"
                placement="top"
              >
                <i class="iconfont icontiaozhengshunxu" />
              </el-tooltip>
            </div>
          </div>
          <div v-if="!defaultCvFirst" class="resume-select">
            <div class="resume-select-title">
              {{ this.cv_lang === "cn" ? "中文简历" : "英文简历" }}
            </div>
            <div class="resume-select-value">
              <img
                class="icon"
                src="https://files.wondercv.com/service_cv.png"
              />
              <div class="text">
                {{ cv_name }}
              </div>
            </div>
          </div>
          <CompleteButton
            type="confirm"
            :disabled="!otherCvToken"
            text=""
            style="width: 178px; margin: 40px auto 0"
            @click="download"
          >
            <template v-slot:content>
              <i class="iconfont iconbaocunbendi1" />
              下载PDF
            </template>
          </CompleteButton>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { routerTo } from "@/assets/js/util";
import { mapState } from "vuex";
import CompleteButton from "../CompleteButton/CompleteButton.vue";
import EditorSelect from "../EditorSelect/EditorSelect.vue";

export default {
  name: "campus-code",
  components: {
    CompleteButton,
    EditorSelect,
  },
  props: {
    token: {
      type: String,
      default: "",
    },
    cv_name: {
      type: String,
      default: "",
    },
    cv_lang: {
      type: String,
      default: "cn",
    },
    handleDownload: {
      type: Function,
    },
  },
  data() {
    return {
      defaultCvFirst: true,
      otherCvs: [],
      otherCvToken: "",
      visible: false,
    };
  },
  computed: {
    ...mapState("cv", ["cvs"]),
  },
  methods: {
    async show() {
      this.visible = true;
      await this.$store.dispatch("cv/getCvsList");
      this.otherCvs = this.cvs.filter((x) => x.lang !== this.cv_lang);
    },
    close() {
      this.visible = false;
    },
    // 关闭弹窗
    handleClose() {
      this.$emit("handleClose");
    },
    // 更改中英文顺序
    switchOrder() {
      this.defaultCvFirst = !this.defaultCvFirst;
    },
    // 下载
    download() {
      if (this.otherCvToken) {
        this.$emit("handleDownload", {
          type: "combine",
          tokens: this.defaultCvFirst
            ? [this.token, this.otherCvToken]
            : [this.otherCvToken, this.token],
        });
        this.$emit("handleClose");
      }
    },
    // 创建新简历
    goToMoban() {
      routerTo(`/jianlimoban/`, "_blank");
      this.$emit("handleClose");
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/public";
@import "@/assets/css/variable.scss";
.background-cover {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 299;
}
.combine-cv-container {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 301;
  margin: auto;
  box-sizing: border-box;
  padding: 32px;
  width: 446px;
  height: fit-content;
  background-color: $form-bg-color;
  border-radius: 12px;
  .main_header {
    margin: 0 auto;
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 26px;
    .header_title {
      width: 90px;
      height: 24px;
      font-size: 18px;
      font-weight: 500;
      color: $modal-label-text-color;
      line-height: 24px;
    }
    .close {
      font-size: 20px;
      color: $modal-label-text-color;
      cursor: pointer;
      .iconfont {
        font-size: 20px !important;
      }
    }
  }
  .main_body {
    .resume-select {
      display: flex;
      align-items: center;
      margin-bottom: 18px;
      &-title {
        // width: 56px;
        height: 14px;
        font-size: 12px;
        font-weight: 400;
        color: $modal-label-text-color;
        line-height: 14px;
      }
      &-value {
        background: $modal-input-bg3-color;
        border-radius: 6px;
        margin-left: 14px;
        padding: 10px 16px;
        display: flex;
        align-items: center;
        .icon {
          height: 18px;
          margin-right: 8px;
        }
        .text {
          max-width: 233px;
          width: 233px;
          height: 18px;
          font-size: 14px;
          font-weight: 400;
          color: $modal-label-text-color;
          line-height: 18px;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
        }
      }
      &-select {
        margin-left: 14px;
        width: 287px;
        .el-select {
          ::v-deep(.el-input__inner) {
            background-color: $modal-input-bg2-color;
            color: $text-color;
            border: 1px solid $modal-input-border-color !important;
            border-radius: 6px;
            &:focus,
            &:hover {
              border-color: $modal-input-border-color !important;
            }
            &::placeholder {
              color: $placeholder-color;
            }
          }
        }
      }
      &-switch {
        margin-left: 14px;
        color: #aeb2bd;
        font-size: 15px;
        cursor: pointer;
        &:hover {
          color: #505667;
        }
      }
    }
    .download-btn {
      margin: 40px auto 0;
      width: 178px;
      height: 36px;
      background: rgba(255, 102, 68, 1);
      border-radius: 4px;
      text-align: center;
      line-height: 36px;
      font-size: 14px;
      font-weight: 400;
      color: rgba(255, 255, 255, 1);
      cursor: pointer;
      &:hover {
        background-color: #ff8569;
      }
    }
    .download-btn-disabled {
      cursor: not-allowed !important;
      background-color: #cfcfcf !important;
    }
    .iconbaocunbendi1 {
      margin-top: 1px;
    }
  }
}
</style>
<style lang="scss">
@import "@/assets/css/variable.scss";
.combine-select-option {
  width: 246px;
  max-width: 246px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  .no-resume {
    display: flex;
    align-items: center;
    color: $resume-merge-empty-color;
    .iconfont {
      margin-right: 6px;
    }
  }
}
</style>
<style lang="scss">
@import "@/assets/css/variable.scss";
.resume-merge-select-popper {
  border-color: $modal-input-border-color !important;
  background: $page-bg-sub-color;
  box-shadow: none;
  margin-top: 6px !important;
  .el-scrollbar {
    .el-select-dropdown__wrap {
      .el-select-dropdown__list {
        background: $modal-input-bg2-color;
        border-radius: 6px;
        .el-select-dropdown__item {
          padding: 0;
          margin: 0 20px;
          color: $modal-label-text-color;
          &:not(:first-child) {
            border-top: 1px solid $modal-input-border-color;
          }
          .es-highlighter {
            color: $theme-color;
          }
          &.hover,
          &:hover {
            color: $theme-color;
            background: $modal-input-bg2-color;
          }
        }
      }
    }
  }
  .popper__arrow {
    display: none;
  }
}
</style>
